export const deviceTypeList = {
    1: 'Desktop',
    2: 'Phone'
};

export const getDeviceTypeName = (deviceType) => {
    return deviceTypeList[deviceType]
}